import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get saved language from localStorage or default to 'tr'
    return localStorage.getItem('vav_language') || 'tr';
  });

  useEffect(() => {
    localStorage.setItem('vav_language', language);
    document.documentElement.lang = language;
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'tr' ? 'en' : 'tr');
  };

  // Helper function to get text based on current language
  const t = (trText, enText) => {
    if (language === 'en' && enText) {
      return enText;
    }
    return trText;
  };

  // Helper to get field with _en suffix
  const getLocalizedField = (obj, field) => {
    if (!obj) return '';
    if (language === 'en' && obj[`${field}_en`]) {
      return obj[`${field}_en`];
    }
    return obj[field] || '';
  };

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    isEnglish: language === 'en',
    isTurkish: language === 'tr',
    t,
    getLocalizedField
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
